<div class="ng-box">
  <div class="container">
    <div class="row">
      <div *ngIf="productCategory.iconUrl"
        class="col-2 align-self-center justify-content-center product-image-container d-none d-sm-block">
        <div>
          <div class="text-center">
            <img class="ng-box-img product-image" [attr.src]="productCategory.iconUrl"
              onerror="this.style.display='none'">
          </div>
        </div>
      </div>
      <div class="col-12 align-self-center text-center text-sm-left col-sm-4 col-md-4 col-lg-5">
        <div>
          <h3 class="product-pack-name">{{productCategory.name | translate}}</h3>
        </div>
      </div>
      <div
        class="col article-one align-self-center justify-content-center justify-content-sm-end text-right my-2 my-lg-0 article-selector-2">
        <div></div>
        <div >
          <fa-icon [icon]="productCategory.isLevelUp ? faLevelUpAlt : faArrowCircleRight"></fa-icon>
        </div>
      </div>
    </div>
  </div>
</div>
